export default {
      id: "icon-lactose-usage",
      viewBox: "0 0 36 80.788",
      url: __webpack_public_path__ + "icons.svg#icon-lactose",
      toString: function () {
        return this.url;
      }
    }